import '../../../stylesheets/namespace/MagazineSidebar.css'
import '../../../stylesheets/namespace/MagazineArticle.css'

import LazyLoad from 'vanilla-lazyload'
import Vue from 'vue'
import { THRESHOLD, LOADED_SELECTOR } from '@/common/constants'
import Sidebar from './Sidebar.vue'
import { getJsonData } from '@/common/utils/dom'
import { LinkCategory, CmsSidebarRelatedItems } from '../types'

const lazyloadOptions = {
  elements_selector: '.ma-Article img',
  threshold: THRESHOLD,
  class_loaded: LOADED_SELECTOR
}

const runLazyLoad = () => {
  if (!window.lazyLoadInstance)
    window.lazyLoadInstance = new LazyLoad(lazyloadOptions)
  window.lazyLoadInstance.update()
}

const initMagazineActiclePage = () => {
  document.addEventListener('DOMContentLoaded', () => {
    runLazyLoad()
  })
}


const initSidebar = () => {
  const mountEl = document.querySelector('#js-sidebar-app')
  // eslint-disable-next-line @typescript-eslint/ban-types
  const linkCategory: LinkCategory | null = getJsonData('#json-link-category')
  const relatedCmsMagazines: CmsSidebarRelatedItems[] = getJsonData('#json-related-cms-magazines')
  const relatedCmsCategories: CmsSidebarRelatedItems[] = getJsonData('#json-related-cms-categories')

  if (!mountEl) {
    return
  }

  new Vue({
    render: h => h(Sidebar, { props: { linkCategory, relatedCmsMagazines, relatedCmsCategories } })
  }).$mount(mountEl)
}
initMagazineActiclePage()
initSidebar()
